import React, { useContext } from "react";
import { GroupContext } from "./context";
import { useFormikContext } from "formik";
import { find } from "lodash";
import { Tooltip } from "@mui/material";
import { OwcIconButton } from "@one/react";
import { BookingAccessControlContext } from "../BookingAccessControlContext";
import { ACTIONS_ROW_STYLE } from "../../components/tableMetaHelpers";

const Actions = ({ item }) => {
  const { setDialogOpen, setIsEditMode, requestDelete, userList } =
    useContext(GroupContext);
  const { openAllWithGroupSearch } = useContext(BookingAccessControlContext);
  const formik = useFormikContext();
  const createUserObj = (list) => {
    const filteredList = [];
    (list || []).forEach((group) => {
      const obj = find(userList, { email: group?.email });
      if (obj) filteredList.push(obj);
    });
    return filteredList;
  };
  return (
    <div style={ACTIONS_ROW_STYLE}>
      <Tooltip
        data-testid={"booking-admin-table-filter-by-group-tooltip-" + item.groupName}
        title={"Search rules using this group"}
        placement="left"
        arrow
      >
        <OwcIconButton
          key={`booking-admin-table-filter-by-group-button-${item.groupName}`}
          data-testid={`booking-admin-table-filter-by-group-button-${item.groupName}`}
          onClick={() => {
            openAllWithGroupSearch(item?.groupName || "");
          }}
          icon="search"
          type="legacy"
          flat
        />
      </Tooltip>
      <Tooltip
        data-testid={"equipment-edit-button-tooltip" + item.groupName}
        title={"Edit group access"}
        placement="left"
        arrow
      >
        <OwcIconButton
          key={`booking-admin-table-edit-instrument-button-${item.groupName}`}
          data-testid={`booking-admin-table-edit-instrument-button-${item.groupName}`}
          onClick={() => {
            setIsEditMode(true);
            formik.resetForm();
            formik.setFieldValue("groupName", item.groupName, true);
            formik.setFieldValue("users", createUserObj(item?.cidmGroup?.groupName?[]:item.users), true);
            formik.setFieldValue("useCIDMMembership", Boolean(item?.cidmGroup?.groupName), true);
            formik.setFieldValue("groupNameCIDM", item?.cidmGroup?.groupName, true);
            formik.setFieldValue("cidmRequestUrl", item?.cidmGroup?.cidmUrl??'', true);
            formik.setFieldValue("groupId", item?.cidmGroup?.groupId ??'', true);
            formik.setFieldValue("moreInfoUrl", item?.cidmGroup?.moreInfoUrl??'', true);
            setDialogOpen(true);
          }}
          icon="edit"
          type="legacy"
          flat
        />
      </Tooltip>
      <Tooltip
        data-testid={"booking-admin-table-delete-group-tooltip-" + item.groupName}
        title={"Delete group access"}
        placement="left"
        arrow
      >
        <OwcIconButton
          key={`booking-admin-table-delete-group-button-${item.groupName}`}
          data-testid={`booking-admin-table-delete-group-button-${item.groupName}`}
          onClick={() => {
            requestDelete(item);
          }}
          icon="delete"
          type="legacy"
          flat
        />
      </Tooltip>
    </div>
  );
};
export default Actions;
